export default "__VITE_ASSET__8c1db733__"